// extracted by mini-css-extract-plugin
module.exports = {"ai-product-intro-list":"fO","aiProductIntroList":"fO","ai-product-intro-list-title":"fP","aiProductIntroListTitle":"fP"};